import { SsoService } from 'services/SsoService';

export const ssoService = new SsoService();
